const EntryService = require('../services/EntryService').default;
const entryCreate = require('./contentful/entry-create');
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/lease');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  save(lease, depth) {
    if (lease.id) {
      return gettingEntryService().then((service) => service.save(lease, depth));
    }

    const data = transformer.internalToContentful(lease);
    return getSpace().then((space) =>
      entryCreate(space, 'lease', data).then(
        (entry) => linkResolve(space, entry.toPlainObject(), depth)
      ).then(transformer.contentfulToInternal)
    );
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  },

  getAll(depth = 0, makeId = null) {
    return getSpace().then((space) => {
      const params = {
        content_type: 'lease',
        order: '-sys.updatedAt',
        limit: 999
      };

      if (makeId) {
        params['fields.make.sys.id'] = makeId;
      }

      return space.getEntries(params).catch(
        processError
      ).then((response) => {
        const data = response.toPlainObject();
        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  getByModelId(modelId, depth = 0) {
    if (!modelId) {
      throw new Error('Expected non-falsy model ID.');
    }

    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'lease',
        'fields.model.sys.id': modelId,
        'order': 'fields.priority,-sys.updatedAt'
      }).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();
        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  createEmpty() {
    return {
      published: false,
      updated: false,
      draft: true,
      archived: false,
      content_type: 'lease',

      name: '',
      term: null,
      advance: null,
      advanceMax: null,
      arrangementFee: null,
      price: null,
      priceMin: null,
      interest: null,
      prices: null,
      pricesMin: null,

      model: null,
      variants: []
    };
  }
};
